import {
  LayoutDashboard,
  Package,
  Users,
  MapPin,
  Truck,
  Container,
  UserCircle,
  CalendarClock,
  Globe,
  Warehouse,
  Shield,
  type LucideIcon,
} from "lucide-react";

export type NavItem = {
  title: string;
  icon: LucideIcon;
  path: string;
  adminOnly?: boolean;
};

export const mainNavItems: NavItem[] = [
  { title: "Dashboard", icon: LayoutDashboard, path: "/" },
  { title: "Orders", icon: Package, path: "/orders" },
  { title: "Schedule", icon: CalendarClock, path: "/schedule" },
  { title: "In Transit", icon: Globe, path: "/atlas" },
  { title: "Yard View", icon: Warehouse, path: "/yard-view" },
];

export const configItems: NavItem[] = [
  { title: "Customers", icon: Users, path: "/customers" },
  { title: "Locations", icon: MapPin, path: "/locations" },
  { title: "Tractors", icon: Truck, path: "/tractors" },
  { title: "Trailers", icon: Container, path: "/trailers" },
  { title: "Drivers", icon: UserCircle, path: "/drivers" },
  { title: "Admin", icon: Shield, path: "/admin", adminOnly: true },
];